export default "__VITE_ASSET__13e1a74b__"